export function ShopEmpty({ title = "Store launching soon", note = "Products will appear here the moment the Shopify catalog is connected." }) {
  return (
    <div className="border border-white/10 rounded-2xl bg-[#0e0e10] py-20 px-6 text-center" data-testid="shop-empty">
      <div className="w-12 h-12 mx-auto rounded-full bg-sh-blue/15 grid place-items-center mb-5">
        <span className="w-2.5 h-2.5 rounded-full bg-sh-blue shadow-[0_0_16px_#0a84ff]" />
      </div>
      <p className="font-display text-xl font-semibold">{title}</p>
      <p className="text-white/50 text-sm mt-2 max-w-md mx-auto">{note}</p>
    </div>
  );
}

export function ProductSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="aspect-[4/5] rounded-2xl bg-white/5" />
      <div className="h-4 bg-white/5 rounded mt-4 w-2/3" />
      <div className="h-4 bg-white/5 rounded mt-2 w-1/3" />
    </div>
  );
}
